export default {

    state: {
        pagamento: null,
        msgCrud: null,
        devedor: null,
        indice: null,
        receitaDiversa: null,
        honorariosAcaoJudicial: null,
        comunicacaoTransferencia: null,
        honorariosProtesto: null,
        requisicaoEfSefa: null,
        requisicaoComTransfEfSefa: null,
        tipoTrp: null,
        salarioMinimo: null
    },

    mutations: {
        setPagamento(state, payload) {
            state.pagamento = payload;
        },
        setMsgCrud(state, payload) {
            state.msgCrud = payload;
        },
        setDevedor(state, payload) {
            state.devedor = payload;
        },
        setIndice(state, payload) {
            state.indice = payload;
        },
        setReceitaDiversa(state, payload) {
            state.receitaDiversa = payload;
        },
        setHonorariosAcaoJudicial(state, payload) {
            state.honorariosAcaoJudicial = payload;
        },
        setComunicacaoTransferencia(state, payload) {
            state.comunicacaoTransferencia = payload;
        },
        setHonorariosProtesto(state, payload) {
            state.honorariosProtesto = payload;
        },
        setRequisicaoEfSefa(state, payload) {
            state.requisicaoEfSefa = payload;
        },
        setRequisicaoComTransfEfSefa(state, payload) {
            state.requisicaoComTransfEfSefa = payload;
        },
        setTipoTrp(state, payload) {
            state.tipoTrp = payload;
        },
        setSalarioMinimo(state, payload) {
            state.salarioMinimo = payload;
        }

    },

    getters: {
        getPagamento(state) {
            return state.pagamento;
        },
        getMsgCrud(state) {
            return state.msgCrud;
        },
        getDevedor(state) {
            return state.devedor;
        },
        getIndice(state) {
            return state.indice;
        },
        getReceitaDiversa(state) {
            return state.receitaDiversa;
        },
        getHonorariosAcaoJudicial(state) {
            return state.honorariosAcaoJudicial;
        },
        getComunicacaoTransferencia(state) {
            return state.comunicacaoTransferencia;
        },
        getHonorariosProtesto(state) {
            return state.honorariosProtesto;
        },
        getRequisicaoEfSefa(state) {
            return state.requisicaoEfSefa;
        },
        getRequisicaoComTransfEfSefa(state) {
            return state.requisicaoComTransfEfSefa;
        },
        getTipoTrp(state) {
            return state.tipoTrp;
        },
        getSalarioMinimo(state) {
            return state.salarioMinimo;
        }
    },

    actions: {
        setPagamento({commit}, pagamento) {
            commit('setPagamento', pagamento);
        },
        setMsgCrud({commit}, msgCrud) {
            commit('setMsgCrud', msgCrud);
        },
        setDevedor({commit}, devedor) {
            commit('setDevedor', devedor);
        },
        setIndice({commit}, indice) {
            commit('setIndice', indice);
        },
        setReceitaDiversa({commit}, receitaDiversa) {
            commit('setReceitaDiversa', receitaDiversa);
        },
        setHonorariosAcaoJudicial({commit}, honorariosAcaoJudicial) {
            commit('setHonorariosAcaoJudicial', honorariosAcaoJudicial);
        },
        setHonorariosProtesto({commit}, honorariosProtesto) {
            commit('setHonorariosProtesto', honorariosProtesto);
        },
        setComunicacaoTransferencia({commit}, comunicacaoTransferencia) {
            commit('setComunicacaoTransferencia', comunicacaoTransferencia);
        },
        setRequisicaoEfSefa({commit}, requisicaoEfSefa) {
            commit('setRequisicaoEfSefa', requisicaoEfSefa);
        },
        setRequisicaoComTransfEfSefa({commit}, requisicaoComTransfEfSefa) {
            commit('setRequisicaoComTransfEfSefa', requisicaoComTransfEfSefa);
        },
        setTipoTrp({commit}, tipoTrp) {
            commit('setTipoTrp', tipoTrp);
        },
        setSalarioMinimo({commit}, salarioMinimo) {
            commit('setSalarioMinimo', salarioMinimo);
        }
    },

}